import React from 'react'

const MobileNavigation = ({
  isMobileTopLevelMenuVisible,
  handleMainCategoryClick,
  activeMainCategory,
  handleNavigation,
  handleDuplicatesClick,
  handleFavoritesClick,
  handleDeletedClick,
  handleKinNavigation,
  closeAllMenus,
  handleUploadClick
}) => {
  return (
    <div
      className={`mobile-nav-pane ${
        isMobileTopLevelMenuVisible ? 'active' : ''
      }`}
    >
      <ul id="top-level-menu" className="shadow04">
        <li
          className="primary-font bold mobile-top-level-link01"
          onClick={() => handleMainCategoryClick('viewFiles')}
        >
          View Gallery
        </li>
        {activeMainCategory === 'viewFiles' && (
          <>
            <li
              className="mobile-top-level-link01 sub-category"
              onClick={e => handleNavigation(e, '/gallery')}
            >
              photos
            </li>
            <li
              className="mobile-top-level-link01 sub-category"
              onClick={e => handleDuplicatesClick(e)}
            >
              duplicates
            </li>
            <li
              className="mobile-top-level-link01 action-nav-link sub-category"
              onClick={e => handleFavoritesClick(e)}
            >
              favorites
            </li>
            <li
              className="mobile-top-level-link01 sub-category"
              onClick={e => handleDeletedClick(e)}
            >
              deleted
            </li>
          </>
        )}

        <li
          className="primary-font bold mobile-top-level-link01"
          onClick={() => handleMainCategoryClick('kinCategories')}
        >
          Create-A-Kin-Categories
        </li>
        {activeMainCategory === 'kinCategories' && (
          <>
            <li
              className="mobile-top-level-link01"
              onClick={e => handleKinNavigation(e, 'Birthday', closeAllMenus)}
            >
              Birthday
            </li>
            <li
              className="mobile-top-level-link01"
              onClick={e => handleKinNavigation(e, 'Wedding', closeAllMenus)}
            >
              Wedding
            </li>
            <li
              className="mobile-top-level-link01"
              onClick={e =>
                handleKinNavigation(e, 'Events & Locations', closeAllMenus)
              }
            >
              Events And Locations
            </li>
          </>
        )}
        <li
          className="primary-font bold mobile-top-level-link01"
          onClick={() => handleMainCategoryClick('buildYourOwn')}
        >
          Build Your Own
        </li>
        {activeMainCategory === 'buildYourOwn' && (
          <>
            <li className="mobile-top-level-link01 sub-category">
              Coming Soon *{' '}
            </li>
          </>
        )}

        <li
          className="mobile-top-level-link01 secondary"
          onClick={handleUploadClick}
        >
          Upload
        </li>
      </ul>
    </div>
  )
}

export default MobileNavigation
